import { connect } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getDeviationById } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { getModuleData, getModuleVersion } from '../../../selectors/modules';
import { DEFAULT_COLOR } from './constants';
export default connect((state: AppState, ownProps) => {
  const moduleVersion = getModuleVersion(state, ownProps.moduleId);
  const moduleData = getModuleData(state, ownProps.moduleId);
  const image = getDeviationById(state, moduleData.image);
  const {
    customtext,
    backgroundType,
    imageDisplayMode,
    imageTint,
    pattern,
    gradient,
    color = DEFAULT_COLOR,
  } = moduleData;
  return {
    ...moduleData,
    moduleVersion,
    image,
    customtext,
    backgroundType,
    imageDisplayMode,
    imageTint,
    pattern,
    gradient,
    color,
  };
});
